// Serviço de tutoriais — leitura do BFF.
//
// O tutorial é a PROJEÇÃO de um artigo da base de conhecimento do CRM: título
// e descrição vêm do artigo, os passos são o checklist dele. Aqui não há
// escrita: publicar/editar acontece no CRM.
import apiClient from './client';
import { endpoints } from './endpoints';

export interface TutorialPasso {
  idPasso: number;
  sequencia: number | null;
  titulo: string | null;
  conteudo: string | null;
}

export interface TutorialResumo {
  idTutorial: number;
  Slug: string;
  /** Já resolvido pelo servidor: do artigo quando é projeção, próprio quando avulso. */
  TituloExibicao: string | null;
  UrlMiniatura: string | null;
  Tags: string | null;
  Dificuldade: string | null;
  DuracaoEstimadaMin: number | null;
  flgDestaque: boolean;
  DataPublicacao: string | null;
  categoria: { idCategoria: number; Categoria: string; Slug: string } | null;
}

export interface TutorialDetalhe {
  idTutorial: number;
  slug: string;
  titulo: string | null;
  descricao: string | null;
  metaTitulo: string | null;
  metaDescricao: string | null;
  urlMiniatura: string | null;
  tags: string | null;
  dificuldade: string | null;
  duracaoEstimadaMin: number | null;
  destaque: boolean;
  publicadoEm: string | null;
  categoria: { idCategoria: number; Categoria: string; Slug: string } | null;
  passos: TutorialPasso[];
}

export interface TutorialListaResp {
  total: number;
  page: number;
  limit: number;
  itens: TutorialResumo[];
}

export interface TutorialListaFiltros {
  q?: string;
  idCategoria?: number;
  destaque?: boolean;
  page?: number;
  limit?: number;
}

export const tutorialService = {
  async list(filtros: TutorialListaFiltros = {}): Promise<TutorialListaResp> {
    const { data } = await apiClient.get<TutorialListaResp>(endpoints.tutorials.list, {
      params: filtros,
    });
    return data;
  },

  async getBySlug(slug: string): Promise<TutorialDetalhe> {
    const { data } = await apiClient.get<TutorialDetalhe>(endpoints.tutorials.get(slug));
    return data;
  },

  /**
   * Busca é a mesma listagem com `q` — o BFF não tem rota `/search` separada.
   * Um endpoint a menos para manter, mesmo resultado.
   */
  async search(q: string, filtros: TutorialListaFiltros = {}): Promise<TutorialListaResp> {
    return this.list({ ...filtros, q });
  },
};
